import {css} from '@mui/material';
import React from 'react';

import {ALERT_ORIGIN_ENUM} from './alert_types';
import {AlertTitleTooltip} from './AlertTitleTooltip';
import {useFormatters} from '../LightFormatter';

type Props = {
  component: string;
  style?: React.CSSProperties;
};

const tagCss = css`
  display: inline-block;
  max-width: 100%;
  font-family: var(--dlFontFamilySemiBold);
  font-size: 11px;
  line-height: 1.4;
  color: var(--dlThemeGray-600);
  background: var(--dlThemeGray-50);
  /* the app's chips' radius (DlMuiChip, e.g. the pharmacotherapy recommendations' patient riskiness) */
  border-radius: 2px;
  padding: 2px 8px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

/** The origin label of an episode's component ("Hospitalizations", "Pharmacotherapy recommendations"), the same as the
 * alert board's Origin column; an unknown component shows as it is. */
export function useAlertOriginLabel(component: string): string {
  const {tEnum} = useFormatters();
  return tEnum(ALERT_ORIGIN_ENUM, component);
}

/** The origin tag of an episode row: the only place the anchor is shown; long tags truncate with an ellipsis. */
export const AlertOriginTag: React.FC<Props> = (props) => {
  const {component, style} = props;
  const label = useAlertOriginLabel(component);
  // the full label in the app's tooltip, for the truncated one
  return (
    <AlertTitleTooltip title={label}>
      <span css={tagCss} style={style} data-name={'dl-alert-origin-tag'} data-component={component}>
        {label}
      </span>
    </AlertTitleTooltip>
  );
};

AlertOriginTag.displayName = 'AlertOriginTag';
